import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BannerImg from "../../../images/locationgcc/qa/revolution.webp";

function Banner(props) {
  return (
    <div
      className="revolution_gcc p-100"
      style={{ backgroundImage: `url(${BannerImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={12} xl={6} xxl={6} className="ms-auto">
            <h2>
              Lead the Evolving Market of Qatar with Our Mobile App Development
              Company
            </h2>
            <p>
              As an experienced mobile app development company, TekRevol
              realizes that the technology future belongs to countries that
              leverage the power of information and communication technology for
              economic development and progress into actionable, knowledge-based
              economies.
            </p>
            <p>
              Businesses in the GCC region are opting for digital transformation
              initiatives to serve their clientele and diversify their customer
              engagement and revenue channels. The entire digital transformation
              business lies on the following building blocks—strategy, focus
              areas, digitization engines, skills and partnerships, and
              investment opportunities.
            </p>
            <p>
              Consequently, you'll gain a competitive advantage in the market,
              paving the way for powerful mobile applications that guarantee a
              higher return on investment (ROI). Take the initiative today to
              consult with us, discuss your project ideas, and embark on the
              journey toward ensuring business sustainability.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              {" "}
              Let’s Get Started
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
